import constants from '../../constants'

const ShoppingBagIcon = ({ ...props }) => {
  return (
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.8408 6H6.15921C5.96818 6.00122 5.78402 6.09698 5.64115 6.26939C5.49828 6.4418 5.40647 6.67906 5.38289 6.93681L4.00493 23.8257C3.99267 23.9728 4.00333 24.1219 4.0362 24.263C4.06907 24.4042 4.12343 24.5344 4.19573 24.6452C4.26803 24.7559 4.35667 24.8448 4.45587 24.9059C4.55507 24.967 4.66263 24.9991 4.77154 25H23.2285C23.3374 24.9991 23.4449 24.967 23.5441 24.9059C23.6433 24.8448 23.732 24.7559 23.8043 24.6452C23.8766 24.5344 23.9309 24.4042 23.9638 24.263C23.9967 24.1219 24.0073 23.9728 23.9951 23.8257L22.6171 6.93681C22.5935 6.67906 22.5017 6.4418 22.3588 6.26939C22.216 6.09698 22.0318 6.00122 21.8408 6V6Z"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 5.75C10.25 4.75544 10.6451 3.80161 11.3483 3.09835C12.0516 2.39509 13.0054 2 14 2C14.9946 2 15.9484 2.39509 16.6517 3.09835C17.3549 3.80161 17.75 4.75544 17.75 5.75"
        stroke="white"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ShoppingBagIcon
